<div class="pagination-section">
  <nz-pagination
    [nzPageIndex]="pageIndex"
    [nzTotal]="totalElements"
    [nzPageSize]="pageSize"
    (nzPageIndexChange)="pageIndexChanged($event)"
  ></nz-pagination>
  <ng-container *ngIf="totalElements">
    <nz-input-number
      [(ngModel)]="jumperValue"
      (keydown.enter)="jumpToPage()"
      (keypress)="onKeyUp($event)"
      [nzMin]="minValue"
      [nzMax]="maxValue"
      [nzStep]="stepValue"
    ></nz-input-number>
    <button type="button" nz-button nzType="primary" (click)="jumpToPage()">
      {{ "app.label.goto" | translate }}
    </button>
  </ng-container>
</div>
